import script from "./Layoutview.vue?vue&type=script&setup=true&lang=js"
export * from "./Layoutview.vue?vue&type=script&setup=true&lang=js"

import "./Layoutview.vue?vue&type=style&index=0&id=776aef14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-776aef14"]])

export default __exports__